import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { get, isEmpty } from 'underscore';
import { askForNewPassword } from 'api/password_reset';

import Template from 'src/components/templates/ForgotPassword/ForgotPassword.jsx';

const ForgotPassword = () => {
    const history = useHistory();
    const methods = useForm();

    const onSubmit = async ({ email }) => {
        askForNewPassword(email)
            .then(() => history.push('/forgot_password/success'))
            .catch(error => {
                const detailErrors = get(error, ['body', 'detail', 'errors']);
                if (isEmpty(detailErrors)) {
                    return;
                }
                methods.setError('root.alert', {
                    type: 'info',
                    message: Object.values(detailErrors).join('\n'),
                });
            });
    };

    return (
        <FormProvider {...methods}>
            <Template onSubmit={onSubmit} />
        </FormProvider>
    );
};

export default ForgotPassword;
